// v0.46.7 — Shared page-title heading. Standardises the top-of-screen
// <h1> size that had drifted across screens (20/22/24/28px inline).
//
// One canonical size via the --text-h1 token (24px, defined in
// src/styles/tokens.css) so every page title matches. Callers can still
// pass className / style / children to tweak per-screen (e.g. an inline
// icon, a specific margin) without re-introducing size drift.
//
// Tiny + dependency-free on purpose. Default colour is var(--text-900);
// margin is 0 so screens control their own spacing as before.

import React from 'react';

export default function PageHeading({ children, className, style, ...rest }) {
  return (
    <h1
      className={className}
      style={{
        fontSize: 'var(--text-h1)',
        fontWeight: 800,
        color: 'var(--text-900)',
        margin: 0,
        letterSpacing: '-0.3px',
        ...style,
      }}
      {...rest}
    >
      {children}
    </h1>
  );
}
